import { createSelector } from "@ngrx/store";
import { selectDataState } from "../../data.selectors";

// **************************************************************************
// SALES CREDIT ROLES SELECTORS
// **************************************************************************
export const selectSalesCreditRoleState = createSelector(selectDataState, state => state.salesCreditRole);
export const selectSalesCreditRoles = createSelector(selectSalesCreditRoleState, state => state.salesCreditRoles);
export const selectActiveSalesCreditRoles = createSelector(selectSalesCreditRoleState, state => state.salesCreditRoles.filter(r => r.isActive));
export const selectSalesCreditRolesLoading = createSelector(selectSalesCreditRoleState, state => state.salesCreditRolesLoading);
